import { useState, useEffect } from 'react';
import EfImg from '@elem/ui/ef-img';
import { useRouter } from 'next/router';
import EfEmarsysEmail from '@elem/ui/ef-emarsys-email';
import Efmodal from 'elem/ui/ef-modal';
import EfLink from 'elem/ui/ef-link';
import { useProductStore } from '../../../ProductProvider';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('power_kits_48v_system');
    const { locale } = useRouter();
    const [topH, setTopH] = useState(0);
    const { pageStatus } = useProductStore();
    const [isTeaser, setIsTeaser] = useState(pageStatus === 'statusA');
    const [showModal, setShowModal] = useState(false);
    const { getSystemTime } = useGlobal();
    const systemTime = getSystemTime();
    const date = new Date(systemTime);
    // 格式化时间
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;

    const fieldsLocal = {
        us: [
            {
                id: '11149',
                type: 'text',
                overwrite: true,
                value: dateString,
            },
            {
                id: '11150',
                type: 'multiple',
                value: [1],
                overwrite: false,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '4423',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '9435',
                type: 'multiple',
                value: [15],
                overwrite: false,
            },
        ],
        eu: [
            {
                id: '4427',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '7596',
                type: 'multiple',
                value: [33],
                overwrite: false,
            },
            {
                id: '9690',
                type: 'multiple',
                value: [12],
                overwrite: false,
            },
        ],
        de: [
            {
                id: '4425',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '7596',
                type: 'multiple',
                value: [33],
                overwrite: false,
            },
            {
                id: '9690',
                type: 'multiple',
                value: [12],
                overwrite: false,
            },
        ],
        uk: [
            {
                id: '4430',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '7596',
                type: 'multiple',
                value: [33],
                overwrite: false,
            },
            {
                id: '9690',
                type: 'multiple',
                value: [12],
                overwrite: false,
            },
        ],
    };

    const termsLocal = {
        us: 'I consent to the <a href="https://us.ecoflow.com/policies/terms-of-service" target="_blank">Terms of Use</a> and <a href="https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html" target="_blank">Privacy Policy</a>.',
        eu: 'I consent to the <a href="https://eu.ecoflow.com/policies/terms-of-service" target="_blank">Terms of Use</a> and <a href="https://eu.ecoflow.com/policies/privacy-policy" target="_blank">Privacy Policy</a>.',
        de: 'Ich stimme den <a href="https://de.ecoflow.com/policies/terms-of-service" target="_blank">Nutzungsbedingungen</a> und der <a href="https://de.ecoflow.com/policies/privacy-policy" target="_blank">Datenschutzerklärung</a> zu.',
        uk: 'I consent to the <a href="https://uk.ecoflow.com/policies/terms-of-service" target="_blank">Terms of Use</a> and <a href="https://uk.ecoflow.com/policies/privacy-policy" target="_blank">Privacy Policy</a>.',
    };

    const configs = {
        needTerms: true,
        tipsObj: {
            btnText: t('V_btn'),
            placeholder: t('V_placeholder'),
        },
        callback: (statu: 'fail' | 'success') => {
            setShowModal(statu === 'success');
        },
        termsHtml: termsLocal[locale] || '',
        contactListId: (() => {
            const idMap = {
                us: '1157235157',
                eu: '1890208037',
                de: '17911822',
                uk: '105959553',
            };
            return idMap[locale];
        })(),
        fields: fieldsLocal[locale] || [],
    };

    useEffect(() => {
        if (typeof window !== 'undefined' && !isTeaser) {
            let h = 0;
            const header = document.querySelector('.ecoflow-frame-header');
            if (header) {
                h += header.offsetHeight;
            }
            const nav = document.querySelector('.ef-nav-product');
            if (nav) {
                h += nav.offsetHeight;
            }
            setTopH(h);
        }
    }, []);

    useEffect(() => {
        setIsTeaser(pageStatus === 'statusA');
    }, [pageStatus]);

    return (
        <div className={styles.TheComp} style={isTeaser ? {} : { height: `calc(100vh - ${topH}px)` }}>
            <EfImg
                pc={
                    isTeaser
                        ? 'https://websiteoss.ecoflow.com/upload/image/1724311880986/pk_kv_pc.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1721038250960/pc_kv.jpg'
                }
                h5={
                    isTeaser
                        ? 'https://websiteoss.ecoflow.com/upload/image/1724229121556/m_pk%E9%A2%84%E7%83%ADkv.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1721038211756/m_kv.jpg'
                }
            />
            <div className="info-box">
                {isTeaser && <p className="desc">{t('A_desc')}</p>}
                <p className="title">{t('A_title')}</p>
                {!isTeaser && <p className="desc landing">{t('A_desc')}</p>}
                {isTeaser && locale !== 'us' && (
                    <>
                        <p className="email-title">
                            {t.rich('V_title', {
                                g: (tx: string) => <span className="g">{tx}</span>,
                            })}
                        </p>
                        {locale != 'uk' && <EfEmarsysEmail {...configs} />}
                        <div className="tip-box">
                            <svg className="partner" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M11.7354 15.2599C11.1966 15.0081 9.83461 14.5456 9.83461 14.5456C9.55181 14.5001 9.55926 13.5309 9.56372 13.1896C10.43 12.7043 10.8303 11.4241 10.7887 10.9615C11.4912 10.6582 11.954 9.25519 10.9747 9.35682C11.6847 8.80169 11.704 4.9082 9.08298 4.5639C6.54084 4.23173 6.94419 5.30104 6.64651 5.33441C5.29507 5.50277 4.472 7.13782 5.48409 9.35378C4.44223 9.07925 5.05991 10.8372 5.59423 11.0935C5.55702 11.8246 6.328 12.7619 6.85488 13.1866C6.84149 13.5309 6.88614 14.4136 6.58549 14.5426C6.58549 14.5426 4.27256 15.0992 3.65786 15.4996C3.28726 15.7423 3 18.5753 3 18.5753C7.2 20.4812 16.6 20.105 22 18.5"
                                    stroke="white"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M11 19.5001C11 19.5001 11.9663 15.6517 12.6098 15.4168C13.3948 15.1321 15.2776 14.4973 15.2776 14.4973C15.4266 14.4503 15.5413 13.1806 15.5413 13.1806C15.1614 12.8332 14.5418 12.2582 14.3928 11.4838C13.5512 11.3414 13.0299 9.91798 13.797 9.87528C13.2563 8.16712 14.3526 6.50736 15.5249 6.36644C15.3432 5.79705 15.4117 5.06396 16.6093 5.06396C17.7697 5.06396 17.7697 5.9636 17.6013 6.34508C18.9836 6.33512 19.9444 8.20698 19.3099 9.86816C20.0666 9.81407 19.6837 11.1578 18.9658 11.4112C18.866 12.2653 18.0944 12.9528 17.5998 13.1734C17.5998 13.1734 17.7071 14.4418 17.8635 14.4902C17.8635 14.4902 20.0129 15.024 20.7428 15.4097C21.5278 15.8254 22 18.5001 22 18.5001"
                                    stroke="white"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <div className="tip">
                                {t.rich('V_partner', {
                                    g: (tx: string) => (
                                        <EfLink
                                            className="link"
                                            href={`/${locale}/cooperation`}
                                            target={'_blank'}
                                            datalayer={{
                                                event: 'uaEvent',
                                                event_name: 'clue_join',
                                                page_name: t('A_title'),
                                                list_name: t('A_title'),
                                                button_name: tx,
                                            }}
                                        >
                                            {tx}
                                        </EfLink>
                                    ),
                                })}
                            </div>
                        </div>
                    </>
                )}
            </div>
            {showModal && (
                <Efmodal open={showModal} title="" position="center" callback={() => setShowModal(false)}>
                    <p className="modal-title">{t('V_modal_title')}</p>
                    <p className="modal-desc">{t('V_modal_desc')}</p>

                    <EfLink className="modal-btn" href={t('V_modal_link')}>
                        {t('V_modal_btn')}
                    </EfLink>
                    <p className="modal-tip">{t('V_modal_tip')}</p>
                </Efmodal>
            )}
        </div>
    );
}
